import { gql, type TypedDocumentNode } from "@apollo/client";

export type EmailPreview = {
  subject: string;
  html: string;
};

export interface JobPostReviewRequestEmailPreviewQueryResponse {
  jobPostReviewRequestEmailPreview: EmailPreview;
}

export interface JobPostReviewRequestEmailPreviewQueryVariables {
  jobPostId: string;
  notes?: string | null;
}

export interface EmployerSatisfactionSurveyEmailPreviewQueryResponse {
  employerSatisfactionSurveyEmailPreview: EmailPreview;
}

export interface EmployerSatisfactionSurveyEmailPreviewQueryVariables {
  jobPostId: string;
}

export interface JobApplicationConfirmationEmailPreviewInput {
  jobPostId: string;
  pgaId?: string | null;
  emailAddress?: string | null;
}

export interface JobApplicationConfirmationEmailPreviewQueryResponse {
  jobApplicationConfirmationEmailPreview: EmailPreview;
}

export interface JobApplicationConfirmationEmailPreviewQueryVariables {
  input: JobApplicationConfirmationEmailPreviewInput;
}

export const JOB_POST_REVIEW_REQUEST_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  JobPostReviewRequestEmailPreviewQueryResponse,
  JobPostReviewRequestEmailPreviewQueryVariables
> = gql`
  query JobPostReviewRequestEmailPreview($jobPostId: ID!, $notes: String) {
    jobPostReviewRequestEmailPreview(jobPostId: $jobPostId, notes: $notes) {
      subject
      html
    }
  }
`;

export const EMPLOYER_SATISFACTION_SURVEY_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  EmployerSatisfactionSurveyEmailPreviewQueryResponse,
  EmployerSatisfactionSurveyEmailPreviewQueryVariables
> = gql`
  query EmployerSatisfactionSurveyEmailPreview($jobPostId: ID!) {
    employerSatisfactionSurveyEmailPreview(jobPostId: $jobPostId) {
      subject
      html
    }
  }
`;

export const JOB_APPLICATION_CONFIRMATION_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  JobApplicationConfirmationEmailPreviewQueryResponse,
  JobApplicationConfirmationEmailPreviewQueryVariables
> = gql`
  query JobApplicationConfirmationEmailPreview($input: BackofficeJobApplicationConfirmationEmailPreviewInput!) {
    jobApplicationConfirmationEmailPreview(input: $input) {
      subject
      html
    }
  }
`;
